// extracted by mini-css-extract-plugin
export default {"closeContent":"ImageModal_closeContent__6Wabl","close":"ImageModal_close__18gmx","imgContainer":"ImageModal_imgContainer__bxIga","img":"ImageModal_img__+-WIL"};